import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, RegularShape, Icon } from 'ol/style.js';
import { Text } from 'ol/style';
import { fromLonLat } from 'ol/proj.js';
import { runAnimationFeature, stopAnimationFeature } from 'map/OlExtension'
import { Feature } from 'ol';
import { LineString, Point, Polygon } from 'ol/geom';
import Target from 'ol/events/Target';
import { settingsConfig } from 'utils/commonFunc';
import MinorCrashIcon from '@mui/icons-material/MinorCrash';

export default class EmergencyVehicleLayer extends VectorLayer {
    constructor(map) {
        super({
            name: 'emerVhlLayer',
            source: new VectorSource(),
            // userLayer: true,
            // layerIndex: 1,
        });
        this.map = map;
        this.map?.addLayer(this);

        // if (true) {
        //     const layerName = this.get('name')
        //     this.on('postrender', function (e) {
        //         console.log(`layer postrender ${layerName}`)
        //     });
        // }
    }

    removeRoute = (data) => {
        const vectorSource = this.getSource();
        vectorSource.getFeatures().forEach(feature => {
            if (feature.get('id') === data.serviceId) {
                vectorSource.removeFeature(feature);
            }
        });

        if (vectorSource.getFeatures().length === 0) {
            this.stopFlashFeature()
        }
    }

    addRoute = (data) => {
        var targetFeature = null;
        const vectorSource = this.getSource();
        const features = vectorSource.getFeatures();

        features.forEach(feature => {
            if (feature.get('id') === data.serviceId)
                targetFeature = feature;
        });

        if (targetFeature) { //update 
            const {
                remainRouteList,// 남은경로
                currentLocation,// 차량위치
                selectedCctv,// CCTV
                deviceId,
            } = data;

            if (!remainRouteList)
                return

            const styles = targetFeature.getStyle();
            if (remainRouteList)
                styles[1].setGeometry(new LineString(remainRouteList?.map(p => fromLonLat(p))));
            if (currentLocation){
                styles[2].setGeometry(new Point(fromLonLat(currentLocation)))
                const text = styles[2]?.getText()?.getText();
                if(text)
                {
                    if(text.lastIndexOf("\n()"))
                        styles[2].getText().setText(text.replace("\n()", `\n(${deviceId})`))
                    else
                        styles[2].getText().setText(text.substr(0, text.length - 1, `/${deviceId})`))
                }
            }
            if (selectedCctv?.targetPresetInfo) {
                styles[3].setGeometry(new Polygon([this.getCctvViewPolygon(selectedCctv.openCctvInfo.xy, selectedCctv.targetPresetInfo.xy)]))
                //styles[3].setGeometry(new Point(fromLonLat(selectedCctv.targetPresetInfo.xy)))                
            }
            else
                styles[3].setGeometry(new Point([0,0]))
            //targetFeature.setStyle([...styles])
        }
        else { //create
            const {
                routeList,// 기본경로
                startName,// 목적지
                endName,// 목적지
                serviceName,
                fireStatinName,
                cctvInfos
            } = data;

            if (!routeList)
                return

            const routeCoordinates = routeList.map(p => fromLonLat(p.reverse()))
            const feature = new Feature({
                id: data.serviceId,
                geometry: new LineString(routeCoordinates),
            });
            const routeStyle = new Style({
                stroke: new Stroke({
                    color: 'rgba(200, 200, 200, 0.3)',
                    width: (settingsConfig().mapRouteWidth ?? 8) - 2,
                }),
            });
            const remainRouteStyle = new Style({
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 0.5)',
                    width: settingsConfig().mapRouteWidth ?? 8,
                }),
                zIndex: 1
            });
            const startMarkerStyle = new Style({
                text: new Text({
                    font: settingsConfig().mapEmergencyVehicleFont ?? "16px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                    fill: new Fill({
                        color: "rgba(255, 255, 255, 1)"
                    }),
                    backgroundFill: new Fill({
                        color: "rgba(20, 20, 20, 0.7)"
                    }),
                    backgroundStroke: new Stroke({
                        color: "rgba(25, 255, 25, 0.7)",
                        width: 1,
                    }),
                    padding: [3, 3, 2, 6],
                    textBaseline: "bottom",
                    offsetY: 34,
                    text: startName
                }),
                image: new RegularShape({
                    radius: 6,
                    points: 3,
                    angle: 0, //Math.PI,
                    displacement: [0, -10],
                    fill: new Fill({
                        color: "rgba(0, 255, 25, 0.7)"
                    })
                }),
                geometry: new Point(routeCoordinates[0]),
                zIndex: 2
            })
            const endMarkerStyle = new Style({
                text: new Text({
                    font: settingsConfig().mapEmergencyVehicleFont ?? "16px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                    fill: new Fill({
                        color: "rgba(255, 255, 255, 1)"
                    }),
                    backgroundFill: new Fill({
                        color: "rgba(20, 20, 20, 0.7)"
                    }),
                    backgroundStroke: new Stroke({
                        color: "rgba(25, 255, 25, 0.7)",
                        width: 1,
                    }),
                    padding: [3, 3, 2, 6],
                    textBaseline: "bottom",
                    offsetY: 34,
                    text: endName
                }),
                image: new RegularShape({
                    radius: 6,
                    points: 3,
                    angle: 0, //Math.PI,
                    displacement: [0, -10],
                    fill: new Fill({
                        color: "rgba(0, 255, 25, 0.7)"
                    })
                }),
                geometry: new Point(routeCoordinates[routeCoordinates.length - 1]),
                zIndex: 2
            })
            const currentMarkerStyle = new Style({
                // text: new Text({
                //     font: settingsConfig().mapEmergencyVehicleFont ?? "16px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                //     fill: new Fill({
                //         color: "rgba(255, 255, 255, 1)"
                //     }),
                //     backgroundFill: new Fill({
                //         color: "rgba(20, 20, 20, 0.7)"
                //     }),
                //     backgroundStroke: new Stroke({
                //         color: "rgba(255, 255, 25, 0.7)",
                //         width: 1,
                //     }),
                //     padding: [3, 3, 2, 6],
                //     textBaseline: "bottom",
                //     offsetY: -15,
                //     text: `${serviceName}\n(${fireStationName})`
                // }),
                // image: new RegularShape({
                //     radius: 6,
                //     points: 3,
                //     angle: Math.PI,
                //     displacement: [0, 10],
                //     fill: new Fill({
                //         color: "rgba(255, 255, 25, 0.7)"
                //     })
                // }),
                image: new Icon({
                  anchor: [0.5, 1],
                  anchorXUnits: 'fraction',
                  anchorYUnits: 'fraction',
                  src: '/images/icons8-car-94.png',
                }),
                // image: new Icon({
                //     opacity: 1,
                //     src: 'images/icons8-car-94.png',
                //     scale: 1
                //   }),
                zIndex: 3
            })
            const presetDebugMarkerStyle = new Style({
                fill: new Fill({ color: 'rgba(220, 220, 220, 0.4)' }),
                stroke: new Stroke({ color: 'rgb(220, 220, 220)', width: 1 }),
                zIndex: 2,
                geometry: new Point([0,0])
            })

            feature.setStyle([routeStyle, remainRouteStyle, currentMarkerStyle, presetDebugMarkerStyle, startMarkerStyle, endMarkerStyle,
                ...this.getCctvMarkerStyles(cctvInfos), 
                //...this.getCctvPresetMarkerStyles(cctvInfos)
            ])

            if (features.length === 0 && !settingsConfig().disableAnimationEmergencyVehicle) {
                //console.log('startFlashFeature', this, data)
                this.startFlashFeature()
            }

            vectorSource.addFeature(feature);
        }
    }

    getCctvMarkerStyles = (cctvInfos) => {
        if (!cctvInfos)
            return []

        return cctvInfos.map((cctvInfo) => {
            return new Style({
                image: new RegularShape({
                    radius: 6,
                    points: 5,
                    angle: 0, //Math.PI,
                    displacement: [0, 0],
                    fill: new Fill({
                        color: "rgba(0, 255, 255, 0.7)" // "rgba(25, 255, 0, 0.7)"
                    })
                }),
                geometry: new Point(fromLonLat(cctvInfo.openCctvInfo.xy)),
                zIndex: 2
            })
        })
    }

    getCctvPresetMarkerStyles = (cctvInfos) => {
        if (!cctvInfos)
            return []

        return cctvInfos.map((cctvInfo) => cctvInfo.openCctvInfo.presetList.map((preset) => {
            return new Style({
                image: new RegularShape({
                    radius: 3,
                    points: 5,
                    angle: 0, //Math.PI,
                    displacement: [0, 0],
                    fill: new Fill({
                        color: "rgba(25, 255, 0, 0.7)"
                    })
                }),
                geometry: new Point(fromLonLat(preset.xy)),
                zIndex: 3
            })
        })).flat()
    }

    getCctvViewPolygon = (lonlatCctv, lonlatView) => {
        var tmPointA = fromLonLat(lonlatCctv);
        var tmPointB = fromLonLat(lonlatView);

        // 크기 키우는 점 생성
        const distanceRatio = settingsConfig().mapCctvViewDistanceRatio ?? 4;
        tmPointB[0] = tmPointA[0] + distanceRatio * (tmPointB[0] - tmPointA[0]);
        tmPointB[1] = tmPointA[1] + distanceRatio * (tmPointB[1] - tmPointA[1]);

        const angle = settingsConfig().mapCctvViewAngle ?? 32;
        var distanceAB = Math.sqrt(Math.pow(tmPointB[0] - tmPointA[0], 2) + Math.pow(tmPointB[1] - tmPointA[1], 2));

        var angleAB = Math.atan2(tmPointB[1] - tmPointA[1], tmPointB[0] - tmPointA[0])
        var pointA_minus15 = [
            tmPointA[0] + distanceAB * Math.cos(angleAB - (angle * Math.PI / 180)),
            tmPointA[1] + distanceAB * Math.sin(angleAB - (angle * Math.PI / 180))
        ];
        var pointA_plus15 = [
            tmPointA[0] + distanceAB * Math.cos(angleAB + (angle * Math.PI / 180)),
            tmPointA[1] + distanceAB * Math.sin(angleAB + (angle * Math.PI / 180))
        ];

        return [pointA_minus15, tmPointA, pointA_plus15, tmPointB]
    }

    startFlashFeature = () => {
        let opacity = 0.5;
        let tick = -0.01;
        runAnimationFeature(this, 'animationKey', 0, (feature, hashTable) => {
            const styles = feature.getStyle();
            //styles[0].getStroke().setColor(`rgba(120, 120, 120, ${(hashTable.opacity + 0.2 > 1 ? 1 : hashTable.opacity + 0.2)})`);
            styles[1].getStroke().setColor(`rgba(255, 0, 0, ${hashTable.opacity})`);
            feature.setStyle(styles);
        }, {
            progressCallBack: (progress, hashTable) => {
                if (opacity >= 0.7) {
                    tick = -0.05
                }
                else if (opacity <= 0.3) {
                    tick = 0.05
                }
                opacity += tick;
                hashTable.opacity = opacity
            }
        });
    }

    stopFlashFeature = () => {
        stopAnimationFeature(this, 'animationKey');
        //console.log('stopFlashFeature', this)
    }
}